function Slider(el) {
  console.log("init slider");
  el.classList.remove("hidden");
  //   const { addEvent, removeEvents } = events;
  const options = el.dataset?.options ? JSON.parse(el.dataset.options) : {};
  const indexEl = el.parentElement.querySelector("[data-index]");

  const flk = new Flickity(el, options);

  function nextSlide() {
    flk.next();
  }

  flk.on("change", (index) => {
    if (indexEl) indexEl.innerText = index + 1;
  });

  function prevSlide() {
    flk.previous();
  }

  document
    .querySelectorAll(options?.nextButton)
    .forEach((el) => el.addEventListener("click", nextSlide));

  document
    .querySelectorAll(options?.prevButton)
    .forEach((el) => el.addEventListener("click", prevSlide));

  document.addEventListener("lazyloaded", (e) => {
    console.log("lazyloaded");
    flk.resize();
  });

  function setActiveBtn(btns, index) {
    btns.forEach((btn) => btn.classList.remove("active"));
    btns[index].classList.add("active");
  }

  if (options.customNav) {
    const btns = [...document.querySelectorAll(options.customNav + " .button")];

    btns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const index = btns.indexOf(btn);
        flk.select(index);
      });
    });

    setActiveBtn(btns, 0);

    flk.on("change", (index) => {
      setActiveBtn(btns, index);
    });
  }

  return () => {
    console.log("destroy slider ");
    flk.destroy();
  };
}

export default Slider;
